import { Container } from "@/components/layout/Container";
import { ProductDetailDialogProvider } from "@/components/product/product-detail-dialog/ProductDetailDialogContext";
import { stockTrackingQuery } from "@/queries/customer/stock-tracking";
import {
  customerOrderStatsQuery,
  customerOrdersQuery,
  customerTopSupplierQuery
} from "@/queries/orders/orders";
import { featuredProductsQuery, saleProductsQuery } from "@/queries/products";
import { queryClient } from "@/queries/queryClient";
import { supplierMatchListQuery } from "@/queries/customer/supplier-match";
import { createRoute } from "@tanstack/react-router";
import { layoutRoute } from "../$layoutRoute";
import { Highlights, RECENT_ORDERS_LIMIT } from "./sections/Highlights";
import { LimitedTimeOffers } from "./sections/LimitedTimeOffers";
import RecommendedForYou from "./sections/RecommendedForYou";
import ShopByCategory from "./sections/ShopByCategory";
import { SupplierMatchWidget } from "./sections/SupplierMatchWidget";
import { WelcomePanel } from "./sections/WelcomePanel";

export const homeRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/",
  component: HomePage,
  loader: () => {
    queryClient.ensureQueryData(featuredProductsQuery());
    queryClient.ensureQueryData(saleProductsQuery());
    // Command-center data for the hero stat grid (#76) + Highlights (#74/#75),
    // which sit above the fold - prefetch to avoid a load waterfall. The recent-
    // orders params must match the Highlights card's `useCustomerOrders` call.
    queryClient.ensureQueryData(customerOrderStatsQuery());
    queryClient.ensureQueryData(
      customerOrdersQuery({ limit: RECENT_ORDERS_LIMIT })
    );
    queryClient.ensureQueryData(customerTopSupplierQuery());
    // Opt-in stock (api#148) feeds the "Due to Reorder" Highlights card (#72)
    // and the hero due-count stat (#73) - both above the fold.
    queryClient.ensureQueryData(stockTrackingQuery());
    // Supplier Match summary widget (ADR-0005) - above the fold.
    queryClient.ensureQueryData(supplierMatchListQuery());
  }
});

function HomePage() {
  return (
    <ProductDetailDialogProvider>
      <WelcomePanel />
      <Container className="space-y-8 py-8">
        <Highlights />
        <SupplierMatchWidget />
        <LimitedTimeOffers />
        <ShopByCategory />
        <RecommendedForYou />
      </Container>
    </ProductDetailDialogProvider>
  );
}
